import request from '@/utils/request'
import { apiUrl } from './config'

type Params = Record<string, unknown>

export interface SentimentRangeItem {
  tradingDay: number
  TotalScore: number
  shChangePct?: number
  szChangePct?: number
  chiNextChangePct?: number
}

export interface SentimentSectorItem {
  name: string
  symbol: string
  market: string
}

export default {
  getRange(data: Params) {
    return request({
      url: apiUrl + '/rjhy-quota-index/api/1/sentiment/barometer/range',
      method: 'get',
      params: data,
      headers: {
        appCode: 'com.rjhy.uranus',
        token: data.token
      },
      sign: true
    })
  },
  getSectorList(data: Params) {
    return request({
      url: apiUrl + '/rjhy-quota-index/api/1/sentiment/barometer/sector/list',
      method: 'get',
      params: data,
      headers: {
        appCode: 'com.rjhy.uranus',
        token: data.token
      },
      sign: true
    })
  }
}
